import React from 'react';
import { useNavigate } from 'react-router-dom';
import MobilePageHeader from '@/components/layout/MobilePageHeader';

const VerificationHeader: React.FC = () => {
  const navigate = useNavigate();

  return (
    <MobilePageHeader 
      title="Verificação de Conta" 
      onBack={() => navigate('/main/profile')} 
    />
  );
};

export default VerificationHeader;
